(() => {
  'use strict';
  if (window.FXLBlogV2) return;
  window.FXLBlogV2 = true;
  const slug = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'onderwerp';
  const initialise = root => {
    root.querySelectorAll('[data-fxl-article]:not([data-fxl-blog-ready])').forEach(article => {
      article.dataset.fxlBlogReady = '';
      const body = article.querySelector('[data-fxl-blog-body]'), toc = article.querySelector('[data-fxl-blog-toc]');
      const headings = [...body.querySelectorAll('h2')].filter(h => !h.closest('[data-fxl-blog-rail]') && h.textContent.trim());
      headings.forEach(h => {
        if (h.id) return;
        const base = slug(h.textContent); let id = base, suffix = 2;
        while (document.getElementById(id)) id = base + '-' + suffix++;
        h.id = id;
      });
      if (toc) {
        const nav = toc.querySelector('nav');
        if (!nav.querySelector('a')) {
          const list = document.createElement('ol');
          headings.forEach(h => { const li = document.createElement('li'), a = document.createElement('a'); a.href = '#' + encodeURIComponent(h.id); a.textContent = h.textContent; li.append(a); list.append(li); });
          nav.replaceChildren(list);
        }
        const links = [...nav.querySelectorAll('a[href^="#"]')].filter(a => {
          let id; try { id = decodeURIComponent(a.hash.slice(1)); } catch { a.closest('li')?.remove(); return false; }
          if (document.getElementById(id)) return true;
          const match = headings.find(h => slug(h.textContent) === slug(a.textContent));
          if (match) { a.href = '#' + encodeURIComponent(match.id); return true; }
          a.closest('li')?.remove(); return false;
        });
        toc.hidden = links.length < 2;
        if (matchMedia('(max-width: 850px)').matches) toc.open = false;
        const targets = links.map(a => document.getElementById(decodeURIComponent(a.hash.slice(1))));
        let scheduled = false;
        const active = () => {
          scheduled = false; let index = 0;
          targets.forEach((target, i) => { if (target.getBoundingClientRect().top <= 140) index = i; });
          links.forEach((a, i) => { if (i === index) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current'); });
        };
        const scroll = () => { if (!article.isConnected) { window.removeEventListener('scroll', scroll); return; } if (!scheduled) { scheduled = true; requestAnimationFrame(active); } };
        if (links.length) { window.addEventListener('scroll', scroll, { passive: true }); active(); }
      }
      body.querySelectorAll('table').forEach(table => { if (table.parentElement.classList.contains('fxlb-table')) return; const wrap = document.createElement('div'); wrap.className = 'fxlb-table'; table.before(wrap); wrap.append(table); });
      article.querySelectorAll('[data-fxl-blog-rail]').forEach(rail => {
        const track = rail.querySelector('[data-fxl-blog-track]'), arrows = rail.querySelector('[data-fxl-blog-arrows]'), buttons = [...arrows.querySelectorAll('button')];
        const update = () => { const max = track.scrollWidth - track.clientWidth; arrows.hidden = max < 2; buttons[0].disabled = track.scrollLeft < 2; buttons[1].disabled = track.scrollLeft >= max - 2; };
        buttons.forEach(button => button.addEventListener('click', () => track.scrollBy({ left: Number(button.dataset.fxlBlogStep) * (track.clientWidth * .85), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' })));
        track.addEventListener('scroll', update, { passive: true });
        const resize = new ResizeObserver(update); resize.observe(track); update();
        document.addEventListener('shopify:section:unload', e => { if (e.target.contains(article)) resize.disconnect(); }, { once: true });
      });
      const copy = article.querySelector('[data-fxl-blog-copy]');
      if (copy && navigator.clipboard?.writeText) { copy.hidden = false; copy.addEventListener('click', async () => { const status = article.querySelector('[data-fxl-blog-copy-status]'); try { await navigator.clipboard.writeText(copy.dataset.url); status.textContent = copy.dataset.success; } catch { status.textContent = copy.dataset.failure; } }); }
    });
  };
  initialise(document);
  document.addEventListener('shopify:section:load', e => initialise(e.target));
})();
